module.exports = __webpack_public_path__ + "img/FR41829.b2c781d1.png";